import { RtkPage } from "@/pages/information/rtk";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/rtk")({
  component: RtkPage,
});
